interface Options {
  desktop: number; // max 24 by default
  mobile?: number; // max 8
}

export function getImageSizesByGridColumns({ desktop, mobile = 8 }: Options): string {
  const desktopWidth = Math.ceil(desktop * (100 / 24));
  const desktopMaxWidth = Math.ceil((1800 / 100) * desktopWidth);
  const mobileWidth = Math.ceil(mobile * (100 / 8));
  const mobileMaxWidth = Math.ceil((580 / 100) * mobileWidth);
  return [
    `(max-width: 580px) ${mobileWidth}vw`,
    `(max-width: 1024px) ${mobileMaxWidth}px`,
    `(max-width: 1800px) ${desktopWidth}vw`,
    `${desktopMaxWidth}px`,
  ].join(', ');
}
